<template>

  <body>

    <div class="bannerWrap">
      <my-header> </my-header>
    </div>
    <div class="webbg">
      <div class="web">
        <div class="producttitle">
          选择颜色 <span>首页 > 产品定制</span>
        </div>

        <div class="productschedule">
          <a class="cur">型号选择</a>
          <a class="cur">选择颜色</a>
          <a>个性设计定制</a>
          <a>个人资料</a>
          <a>确认购买</a>
        </div>

        <div class="productsbox clearfl">

          <div class="product-container">

            <div class="productright">

              <!--为了适应响应式 所以复制结构-->
              <div class="m-productmodel-container">

                <div class="m-productmodel-scroll">
                  <div class="productmodel clearfl">
                    <!--左边耳机-->
                    <div class="productmodelleft"
                         @click='changeselectleft()'>
                      <!--自定义上传-->
                      <div class="headsetcustommade">
                        <div class="custommade leftcustomize"
                             v-bind:style="{backgroundImage:'url('+CustomUplod.leftimg+')',      
                            width:CustomUplod.Lwidth + '%',
                            height:CustomUplod.Lheight + '%',
                            left:CustomUplod.Lleft + '%',
                            top:CustomUplod.Ltop + '%',
                            transform:'rotate('+CustomUplod.Lrotate+'deg) scale('+CustomUplod.Lscale+')'
                      }">

                        </div>
                        <div class="headsetsmalllogo"></div>
                      </div>
                      <!--耳机线-->
                      <div class="headsetline" v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Wleftimg + ')'}"></div>
                      <!--耳机壳-->
                      <div class="headsetmold"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Krightimg + ')'}"></div>
                      <!--耳机壳加金箔粉-->
                      <div class="headsetgold"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.KADDleftimg + ')'}"></div>
                      <!--耳机模-->
                      <div class="headsetcover"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.rightimg + ')'}"></div>
                      <!--耳机模加金箔粉-->
                      <div class="headsetother"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.addleftimg + ')'}"></div>
                      <!--耳机logo-->
                      <div class="headsetBiglogo"
                           v-bind:style="{backgroundImage:'url(' + httpurl + DesignMake.leftlogoimg + ')'}"></div>

                    </div>
                    <!--左边耳机-->

                    <!--右边耳机-->
                    <div class="productmodelright"
                         @click='changeselectright()'>
                      <!--自定义上传-->
                      <div class="headsetcustommade">
                        <div class="custommade rightcustomize"
                             v-bind:style="{backgroundImage:'url('+CustomUplod.rightimg+')',      
                            width:CustomUplod.Rwidth + '%',
                            height:CustomUplod.Rheight + '%',
                            left:CustomUplod.Rleft + '%',
                            top:CustomUplod.Rtop + '%',
                            transform:'rotate('+CustomUplod.Rrotate+'deg) scale('+CustomUplod.Rscale+')'
                      }"></div>
                        <div class="headsetsmalllogo"></div>
                      </div>
                      <!--耳机线-->
                      <div class="headsetline"    v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Wrightimg + ')'}"> </div>
                      <!--耳机壳-->
                      <div class="headsetmold"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Kleftimg + ')'}"> </div>
                      <!--耳机壳加金箔粉-->
                      <div class="headsetgold"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.KADDrightimg + ')'}"></div>
                      <!--耳机模-->
                      <div class="headsetcover"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.leftimg + ')'}"></div>
                      <!--耳机模加金箔粉-->
                      <div class="headsetother"
                           v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.addrightimg + ')'}">></div>
                      <!--耳机logo-->
                      <div class="headsetBiglogo"
                           v-bind:style="{backgroundImage:'url(' + httpurl + DesignMake.rightlogoimg + ')'}"></div>
                    </div>
                    <!--右边耳机-->
                  </div>
                </div>

                <div class="selectheadset"
                     rel="0">
                  <span class="scrollbar"
                        v-bind:style="'left:'+ changeselect + '%'"></span>
                  <dl>
                    <dd class="selectLeft"
                        @click='changeselectleft()'>Left</dd>
                    <dt class="selectPair"
                        @click='changeselectmiddle()'></dt>
                    <dd class="selectRight"
                        @click='changeselectright()'>Right</dd>
                  </dl>
                </div>

              </div>

              <div class="modelselect-container">
                <!--面板颜色-->
                <div class="modelselect">
                  <h3>面板颜色</h3>
                  <dl>
                    <a v-for="(item,index) in PanelColor"
                       :key="index"
                       :class="{'cur':item.id===PanelColorid}"
                       @click="handlePanelColor(index,item.id)">{{item.Name}}</a>
                  </dl>
                  <ul class="clearfl panel"
                      v-if="isLoadingPanelColor">
                    <li v-for="(item,index) in PanelColor[PanelColortype].list"
                        :key="index"
                        flag="prpanel"
                        rel="0"
                        :class="{'cur':item.id==PanelColornumber}"
                        v-bind:style="{'background-color':'#'+item.bgm}"
                        @click='handleLeftimg(index,item)'></li>
                  </ul>

                  <!--  面板加金箔粉-->
                  <p class="panelplusgold"
                     v-show='PanelColornumber!=-1'>

                    <a flag="prpanelGold"
                       v-for="(item,index) in PanelColorOther"
                       :key="index"
                       :class="{'cur':index===PanelOtherColornumber}"
                       @click='handleLeftimg2(index,item)'>{{item.name|filterName}}</a>

                    <!--<a href="javascript:;" class="panelcancel" flag="prpanelGold" rel="0">取消</a>-->
                  </p>
                </div>
                <!--材质面板-->
                <div class="modelselect">

                  <h3>材质面板</h3>
                  <dl>
                    <a v-for="(item,index) in PanelMaterial"
                       :key="index"
                       :class="{'cur':index==PanelMaterialtype}"
                       @click="handlePanelMaterial(index,item.id)">{{item.Name}}</a>
                  </dl>
                  <!-- 木纹-->
                  <ul class="clearfl panel"
                      v-if="isLoadingPanelMaterial">

                    <li v-for="(item,index) in PanelMaterial[PanelMaterialtype].list"
                        :key="index"
                        flag="prpanel"
                        rel="0"
                        v-bind:style="{'background-color': '#'+item.bgm}"
                        @click='handleMLeftimg(index,item)'
                        :class="{'cur':item.id==PanelMaterialnumber}"></li>

                  </ul>

                </div>
                <!--壳体颜色-->
                <div class="modelselect">

                  <h3>壳体颜色</h3>
                  <dl>
                    <a v-for="(item,index) in ShellColor"
                       :key="index"
                       :class="{'cur':index===ShellColortype}"
                       @click="handleShellColor(index,item.id)">{{item.Name}}</a>
                  </dl>

                  <ul class="clearfl case"
                      v-if='isLoadingShellColor'>
                    <li v-for="(item,index) in ShellColor[ShellColortype].list"
                        :key="index"
                        flag="prpanel"
                        rel="0"
                        v-bind:style="{'background-color': '#'+item.bgm}"
                        @click='handleShellimg(index,item)'
                        :class="{'cur':item.id==Shellnumber}"></li>
                  </ul>

                  <p class="caseplusgold">
                    <a flag="prpanelGold"
                       v-for="(item,index) in PanelOther"
                       :key="index"
                       :class="{'cur':index===PanelOtherShellColornumber}"
                       @click='handleShellimg2(index,item)'>{{item.name|filterName}}</a>
                  </p>
                </div>

              </div>

              <div class="modelselectNext">
                <a @click='back()'>上一步</a>
                <a @click='make(SelectDesign, SumPrice)'
                   class="cur">下一步</a>
              </div>

            </div>

            <div class="productleft">

              <div class="productmodel-container">

                <div class="productmodel clearfl">
                  <!--左边耳机-->
                  <div class="productmodelleft">
                    <!--自定义上传-->
                    <div class="headsetcustommade">
                      <div class="custommade leftcustomize"
                           v-bind:style="{backgroundImage:'url('+CustomUplod.leftimg+')',      
                            width:CustomUplod.Lwidth + '%',
                            height:CustomUplod.Lheight + '%',
                            left:CustomUplod.Lleft + '%',
                            top:CustomUplod.Ltop + '%',
                            transform:'rotate('+CustomUplod.Lrotate+'deg) scale('+CustomUplod.Lscale+')'
                      }">

                      </div>
                      <div class="headsetsmalllogo"></div>
                    </div>
                    <!--耳机线-->
                    <div class="headsetline" v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Wleftimg + ')'}"> </div>
                    <!--耳机壳-->
                    <div class="headsetmold"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Krightimg + ')'}"></div>
                    <!--耳机壳加金箔粉-->
                    <div class="headsetgold"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.KADDleftimg + ')'}"></div>
                    <!--耳机模-->
                    <div class="headsetcover"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.rightimg + ')'}"></div>
                    <!--耳机模加金箔粉-->
                    <div class="headsetother"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.addleftimg + ')'}"></div>
                    <!--耳机logo-->
                    <div class="headsetBiglogo"
                         v-bind:style="{backgroundImage:'url('+ httpurl + DesignMake.leftlogoimg +  ')'}">
                    </div>

                  </div>
                  <!--左边耳机-->

                  <!--右边耳机-->
                  <div class="productmodelright">
                    <!--自定义上传-->
                    <div class="headsetcustommade">
                      <div class="custommade rightcustomize"
                           v-bind:style="{backgroundImage:'url('+CustomUplod.rightimg+')',      
                            width:CustomUplod.Rwidth + '%',
                            height:CustomUplod.Rheight + '%',
                            left:CustomUplod.Rleft + '%',
                            top:CustomUplod.Rtop + '%',
                            transform:'rotate('+CustomUplod.Rrotate+'deg) scale('+CustomUplod.Rscale+')'
                      }"></div>
                      <div class="headsetsmalllogo"></div>
                    </div>
                    <!--耳机线-->
                    <div class="headsetline" v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Wrightimg + ')'}"> </div>
                    <!--耳机壳-->
                    <div class="headsetmold"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Kleftimg + ')'}"> </div>
                    <!--耳机壳加金箔粉-->
                    <div class="headsetgold"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.KADDrightimg + ')'}"></div>
                    <!--耳机模-->
                    <div class="headsetcover"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.leftimg + ')'}"></div>
                    <!--耳机模加金箔粉-->
                    <div class="headsetother"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.addrightimg + ')'}"></div>
                    <!--耳机logo-->
                    <div class="headsetBiglogo"
                         v-bind:style="{backgroundImage:'url(' + httpurl + DesignMake.rightlogoimg + ')'}">

                    </div>
                  </div>
                  <!--右边耳机-->
                </div>

                <div class="selectheadset"
                     rel="0">
                  <span class="scrollbar"
                        v-bind:style="'left:'+ changeselect + '%'"></span>
                  <dl>
                    <dd class="selectLeft"
                        @click='changeselectleft()'>Left</dd>
                    <dt class="selectPair"
                        @click='changeselectmiddle()'></dt>
                    <dd class="selectRight"
                        @click='changeselectright()'>Right</dd>
                  </dl>
                </div>

              </div>

              <div class="selectheadsettitle">
                <dl class="clearfl">
                  <h3>你的<span class="Pmodel">{{DesginList.Name}}</span></h3>
                  <dt style="width: 100%;">
                    <p><span class="w300">型号：<em class="Pmodel">{{DesginList.Name}}</em></span><span class="w130">￥<i class="modelprice Uniteprice">{{DesginList.Price| toFixed(2)}}</i></span></p>
                    <p><span class="w300">线材：<em class="PWire">{{SelectDesign.Wname}}</em></span><span class="w130">￥<i class="Wireprice Uniteprice">{{SelectDesign.Wprice}}</i></span></p>
                    <p><span class="w300">左耳面板：<em><i class="Pleftpanel">{{SelectDesign.Mleftname}}</i></em></span><span class="w130"
                            style="position: relative; top: 13px;">￥<i class="panelprice Uniteprice">{{SelectDesign.Mprice|toFixed(2)}}</i></span></p>
                    <p><span class="w300">右耳面板：<em><i class="Prightpanel">{{SelectDesign.Mrightname}}</i></em></span></p>
                    <p><span class="w300">左耳壳体：<em><i class="Pleftcase">{{SelectDesign.Kleftname}}</i></em></span><span class="w130"
                            style="position: relative; top: 13px;">￥<i class="caseprice Uniteprice">{{SelectDesign.Kprice|toFixed(2)}}</i></span></p>
                    <p><span class="w300">右耳壳体：<em><i class="Prightcase">{{SelectDesign.Krightname}}</i></em></span></p>
                    <p>
                      <span class="w300">面板（加金箔粉）：

                        <em v-if="SelectDesign.Maddleftnameid===6&&SelectDesign.Maddrightnameid===6">
                          <i class="panelleftplusgold">左</i>
                          <i class="panelrightplusgold">右</i>
                        </em>
                        <em v-if="SelectDesign.Maddleftnameid!==6&&SelectDesign.Maddrightnameid!==6">
                          <i class="panelleftplusgold">左{{SelectDesign.Maddleftname}}</i>
                          <i class="panelrightplusgold">右{{SelectDesign.Maddrightname}}</i>
                        </em>
                        <em v-if="SelectDesign.Maddleftnameid===6&&SelectDesign.Maddrightnameid!==6">
                          <i class="panelleftplusgold">左</i>
                          <i class="panelrightplusgold">右{{SelectDesign.Maddrightname}}</i>
                        </em>
                        <em v-if="SelectDesign.Maddleftnameid!==6&&SelectDesign.Maddrightnameid===6">
                          <i class="panelleftplusgold">左{{SelectDesign.Maddleftname}}</i>
                          <i class="panelrightplusgold">右</i>
                        </em>

                      </span>
                      <span class="w130">￥<i class="panelgoldprice Uniteprice">{{SelectDesign.Maddprice|toFixed(2)}}</i></span></p>
                    <p>
                      <span class="w300">壳体（加金箔粉）：
                        <em v-if="SelectDesign.Kaddleftnameid===7&&SelectDesign.Kaddrightnameid===7">
                          <i class="panelleftplusgold">左</i>
                          <i class="panelrightplusgold">右</i>
                        </em>
                        <em v-if="SelectDesign.Kaddleftnameid!==7&&SelectDesign.Kaddrightnameid!==7">
                          <i class="panelleftplusgold">左{{SelectDesign.Kaddleftname}}</i>
                          <i class="panelrightplusgold">右{{SelectDesign.Kaddrightname}}</i>
                        </em>
                        <em v-if="SelectDesign.Kaddleftnameid===7&&SelectDesign.Kaddrightnameid!==7">
                          <i class="panelleftplusgold">左</i>
                          <i class="panelrightplusgold">右{{SelectDesign.Kaddrightname}}</i>
                        </em>
                        <em v-if="SelectDesign.Kaddleftnameid!==7&&SelectDesign.Kaddrightnameid===7">
                          <i class="panelleftplusgold">左{{SelectDesign.Kaddleftname}}</i>
                          <i class="panelrightplusgold">右</i>
                        </em>

                      </span>
                      <span class="w130">￥<i class="casegoldprice Uniteprice">{{SelectDesign.Kaddprice|toFixed(2)}}</i></span></p>
                    <h4>耳机定制完成时间：<span>2-4周</span></h4>
                  </dt>
                </dl>
              </div>

              <div class="linematerial">
                <h3>线材选择</h3>
                <!--     <h4  ><span>￥<i>2000</i></span><em>标配版（白）镀银铜4C复绞线1.2m</em></h4>-->
                <h4 @click='selectChangeWires()'><span>￥<i>{{SelectDesign.Wprice}} </i></span><em>{{SelectDesign.Wname}}</em></h4>
                <ul :style='{display:!selectWiresVisable?"none":"block"}'>

                  <li @click='selectWires(index,item)'
                      :key="index"
                      v-for="(item,index) in Wires "
                      flag="prline"
                      :leftimg="item.leftimg"
                      pkid="7"
                      :rightimg="item.rightimg"
                      v-show='selectWiresVisable'>
                    <span>￥<i>{{item.price}}</i></span>
                    <em>{{item.name}}</em>
                  </li>

                </ul>
              </div>
              <div class="selectheadseTotalprice"><span>总价格</span>￥<i class="Colourprice">{{SumPrice|toFixed(2)}}</i></div>

              <!--为了适应响应式 所以复制“上一步、下一步”结构-->
              <div class="modelselectNext m-modelselectNext">
                <a @click="back()">上一步</a><a @click='make(SelectDesign, SumPrice)'
                   class="cur">下一步</a>
              </div>

            </div>

          </div>

        </div>
      </div>

    </div>
  </body>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import myHeader from "@/views/designimg";
import {
  getkttx,
  getktmb,
  getczxx,
  getline,
  getdexh,
  tjdexx,
  getmbtx,
  getmbcolor
} from "@/api/api";
// import {getnewDesginList} from '@/api/storage'
export default {
  components: { myHeader },
  data () {
    return {
        RShellprice:'',
        LShellprice:'',
        LPanelprice:'',
        RPanelprice:'',
      visable: false,
      httpurl: "http://shop.qdc.com/",
      MleftAvisable: false,
      Mleftvisable: true,
      MrightAvisable: false,
      Mrightvisable: true,
      SelectDesign: {
          Wleftimg:'',
          Wrightimg:'',
        LogoColorName: "",
        LogoStyleName: "",
        SumPrice: 0,
        leftlogoimg: "",
        rightlogoimg: "",
        leftlogoimg: "",
        rightlogoimg: "",
        addleftimg: "",
        addrightimg: "",
        leftimg: "",
        rightimg: "",
        SumPrice: 0,
        PanelOtherid: 4,
        Krightnameid: '',
        addleftimg: "",
        addrightimg: "",
        //						addleftimg: require("../assets/leftjfkt.png"),
        //						addrightimg: require("../assets/rightjfkt.png"),
        Kleftimg: "",
        Krightimg: "",
        KADDleftimg: "",
        KADDrightimg: "",
        Mleftname: "",
        Mrightname: "",
        Cleftname: "",
        Crightname: "",
        Mleftnameid: "",
        Mrightnameid: "",
        Cleftnameid: "",
        Crightnameid: "",
        Mprice: 0,
        Kaddleftname: "",
        Kaddrightname: "",
        Kaddleftnameid: 3,
        Kaddrightnameid: 3,
        Kaddprice: 0,
        Maddleftname: "",
        Maddrightname: "",
        Maddleftnameid: 4,
        Maddrightnameid: 4,
        Maddprice: 0,
        Kleftname: "",
        Krightname: "",
        Kprice: 0,
        Wid: '',
        Wname: "",
        Wprice: 0
      },
      selectWiresVisable: false,
      PanelColornumber2: -1,
      PanelMaterialnumber: -1,
      PanelMaterialnumber2: -1,
      PanelMaterialnumber3: -1,
      PanelOtherColornumber: -1,
      PanelMaterialid: 1,
      PanelMaterialtype: 0,//面板材质类型
      PanelColorid: 1,
      PanelColortype: 0,//面板颜色类型0不透明，1透明
      PanelColornumber: -1,
      Shellnumber: -1,
      Shellnumber2: -1,
      ShellColorid: 1,
      ShellColortype: 0,
      isLoadingShellColor: false,//是否加载完数据-壳体
      ShellColor: [],//壳体颜色
      isLoadingPanelColor: false,//是否加载完数据-面板
      PanelColor: [],//面板颜色
      isLoadingPanelMaterial: false,//是否加载完数据-面板材质
      PanelMaterial: [],//面板材质
      PanelOtherShellColornumber: -1,
      ShellColorVisible: true,
      PanelColorVisible: true,
      PanelMaterialVisible: true,
      selectWire: false,

      PanelOther: [],
      PanelColorOther: [],

      Wires: [],

      PanelOtherShellid: -1,
      DesignMake: {
        LLogoColorNameid: '',
        RLogoColorNameid: '',
        LLogoColorName: '',
        RLogoColorName: '',
        LLogoStyleName: '',
        RLogoStyleName: '',
        LLogoStyleNameid: '',
        RLogoStyleNameid: '',
        SumPrice: 0,
        leftlogoimg: '',
        rightlogoimg: '',
      },
      CustomUplod: {
        // leftimg: require("../assets/REDIVG.png"),
        leftimg: '',
        rightimg: '',
        Lwidth: 20.5,
        Lheight: 19.7321,
        Lleft: 44.4167,
        Ltop: 50.134,
        Lrotate: 0,
        Lscale: 1,
        Rwidth: 20.5,
        Rheight: 19.7321,
        Rleft: 44.4167,
        Rtop: 50.134,
        Rrotate: 0,
        Rscale: 1
      },
      changeselect: 45
    };
  },
  filters: {
    filterName (data) {
      return data.slice(1, data.length - 1);
    },
  },

  created () {
    //   console.log('  this.SelectDesign.Kaddleftnameid:::'+ this.SelectDesign.Kaddleftnameid)
    this.getlineList();
    this.getmbcolorList();
    this.getmbtxList();
    this.getczxxList();
    this.getktmbList();
    this.getkttxList();
    if (localStorage.getItem("newDesginList") != null || localStorage.getItem("newSelectDesign") != undefined) {
      var list = JSON.parse(localStorage.getItem('newDesginList'));
      this.DesginList = list
    } else {
      this.DesginList = ''
      this.$message({
        message: "您暂未选择设计型号，我们将帮你返回让你进行选择",
        type: 'error'
      });
      this.$router.push('/Design')
    }

    if (localStorage.getItem("newSelectDesign") != null || localStorage.getItem("newSelectDesign") != undefined) {
      var SelectDesign = JSON.parse(localStorage.getItem('newSelectDesign'));
      this.SelectDesign = SelectDesign
       if(SelectDesign.Kaddrightname==''){
             this.SelectDesign.Kaddrightnameid =0
       }
       if(SelectDesign.Kaddleftname==''){
             this.SelectDesign.Kaddleftnameid =0
       }
    } else {
      this.SelectDesign.Kleftimg = 'uploads/admin/image/20160902/2016090210273171.png'
      this.SelectDesign.Krightimg = 'uploads/admin/image/20160902/2016090210272948.png'
      this.SelectDesign.leftimg = 'uploads/admin/image/20160902/2016090209324618.png'
      this.SelectDesign.rightimg = 'uploads/admin/image/20160902/2016090209324285.png'
      this.SelectDesign.Wleftimg = 'uploads/admin/image/20200224/20200224094306_12815.png'
      this.SelectDesign.Wrightimg = 'uploads/admin/image/20200224/20200224094239_19044.png'
    }
    if (localStorage.getItem("newDesignMake") != null || localStorage.getItem("newDesignMake") != undefined) {
      var DesignMake = JSON.parse(localStorage.getItem('newDesignMake'));
      this.DesignMake = DesignMake
    }
    if (localStorage.getItem("newCustomUplod") != null || localStorage.getItem("newCustomUplod") != undefined) {
      var CustomUplod = JSON.parse(localStorage.getItem('newCustomUplod'));
      this.CustomUplod = CustomUplod
    }
    // console.log('this.changeselect:' + this.changeselect)
    // getkttx,getktmb,getczxx,getline,getdexh,tjdexx,getmbtx ,getmbcolor


  },
  computed: {
    // DesginList () {
    //   return this.$store.state.DesginList;
    // },
    SumPrice: function () {
      return (
        parseFloat(this.DesginList.Price) +
        parseFloat(this.SelectDesign.Wprice) +
        parseFloat(this.SelectDesign.Mprice) +
        parseFloat(this.SelectDesign.Maddprice) +
        parseFloat(this.SelectDesign.Kprice) +
        parseFloat(this.SelectDesign.Kaddprice)
      );
    }
  },
  methods: {

    //面板颜色
    getmbcolorList () {
      var para = {};
      getmbcolor(para).then(res => {
        if (res.data.error_code == 200) {
          let panelList = res.data.List
        //   console.log('获取面板颜色成功', panelList)
          this.PanelColor = panelList
          this.isLoadingPanelColor = true
          //   this.SelectDesign.leftimg = panelList[1].list[7].leftimg
          //   this.SelectDesign.rightimg = panelList[1].list[7].rightimg
        } else {
          console.info("请求失败", err);
        }
      }).catch(err => { console.info("调用失败", err); })
    },
    //面板特效
    getmbtxList () {
      var para = {};
      getmbtx(para).then(res => {
        if (res.data.error_code == 200) {
          // console.log("材质面板特效成功", res.data);
          this.PanelColorOther = res.data.PanelOther
        } else {
          console.info("调用失败", res);
        }
      }).catch(err => { console.info("调用失败", err); })
    },
    //材质面板
    getczxxList () {
      var para = {};
      getczxx(para).then(res => {
        if (res.data.error_code == 200) {
        //   console.log("材质请求成功", res.data)
          this.PanelMaterial = res.data.List
          this.isLoadingPanelMaterial = true
        } else {
          console.info("调用失败", res);
        }
      }).catch(err => { console.info("调用失败", err); })
    },
    //壳体面板
    getktmbList () {
      var para = {};
      getktmb(para).then(res => {
        if (res.data.error_code == 200) {
          //   console.log("壳体面板请求成功", res.data);
          this.ShellColor = res.data.List
          this.isLoadingShellColor = true
          //   this.SelectDesign.Kleftimg = res.data.List[0].list[7].leftimg
          //   this.SelectDesign.Krightimg = res.data.List[0].list[7].rightimg
        } else {
          console.info("调用失败", res);
        }
      }).catch(err => { console.info("调用失败", err); })
    },
    //壳体特效
    getkttxList () {
      var para = {};
      getkttx(para).then(res => {
        if (res.data.error_code == 200) {
          // console.log("壳体特效请求成功", res.data);
          this.PanelOther = res.data.PanelOther
        } else {
          console.info("调用失败", res);
        }
      }).catch(err => { console.info("调用失败", err); })
    },
    //线材列表
    getlineList () {
        if (localStorage.getItem("newSelectDesign") != null || localStorage.getItem("newSelectDesign") != undefined){
             var SelectDesign = JSON.parse(localStorage.getItem('newSelectDesign'));
this.SelectDesign.Wid = SelectDesign.pkid;
      this.SelectDesign.Wprice = SelectDesign.price;
      this.SelectDesign.Wname = SelectDesign.name;
      this.SelectDesign.Wleftimg = SelectDesign.leftimg;
      this.SelectDesign.Wrightimg = SelectDesign.rightimg;
        }
      var para = {}
      getline(para).then(res => {
        if (res.data.error_code == 200) {
            var item =res.data.Wires[1]
  
          this.Wires = res.data.Wires
        //   console.log('线材：'+this.Wires)
        } else {
          console.info("调用失败", res);
        }
      }).catch(err => { console.info("调用失败", err); })
    },
    handleShellimg (index, item) {
      this.Shellnumber = item.id;
      if (item.id) {
        this.SelectDesign.Kprice = item.price;
        if (this.changeselect == 45) {
          this.SelectDesign.Kleftimg = item.leftimg;
          this.SelectDesign.Krightimg = item.rightimg;
          this.SelectDesign.Kleftname = item.name;
          this.SelectDesign.Krightname = item.name;
          this.SelectDesign.Kleftnameid = item.id;
          this.SelectDesign.Krightnameid = item.id;
        }
        if (this.changeselect == 1) {
          this.SelectDesign.Krightnameid = item.id;
          this.SelectDesign.Krightimg = item.rightimg;
          this.SelectDesign.Kleftname = item.name;
        }
        if (this.changeselect == 90) {
          this.SelectDesign.Kleftimg = item.leftimg;
          this.SelectDesign.Kleftnameid = item.id;
          this.SelectDesign.Krightname = item.name;
        }
      }
    },
    handleShellimg2 (index, item) {
      //				this.$set(item,'checked',!item.checked);
      this.PanelOtherShellColornumber = index;
    //    this.SelectDesign.Kaddprice = item.price;
       var price = item.price
      if (item.id) {
        this.PanelOtherShellid = item.id;
        if (this.changeselect == 45) {
          this.SelectDesign.KADDleftimg = item.leftimg;
          this.SelectDesign.KADDrightimg = item.rightimg;
          this.SelectDesign.Kaddleftname = item.name;
          this.SelectDesign.Kaddrightname = item.name;
          this.SelectDesign.Kaddleftnameid = item.id;
          this.SelectDesign.Kaddrightnameid = item.id;
        // this.SelectDesign.Kaddprice = item.price;
        this.LShellprice=item.price
         this.RShellprice=item.price
        }
        if (this.changeselect == 90) {
          this.SelectDesign.KADDrightimg = item.rightimg;
          this.SelectDesign.Kaddrightname = item.name;
          this.SelectDesign.Kaddleftnameid = item.id;
       this.LShellprice=item.price
        }
        if (this.changeselect == 1) {
          this.SelectDesign.KADDleftimg = item.leftimg;
          this.SelectDesign.Kaddleftname = item.name;
          this.SelectDesign.Kaddrightnameid = item.id;
          this.RShellprice=item.price
        }
      }
this.SelectDesign.Kaddprice=Math.max(this.RShellprice,this.LShellprice)
   
    },
    //
    handleLeftimg (index, item) {
      this.PanelColornumber = item.id;
       
      //   console.log(item)
      if (item.id) {
        this.SelectDesign.Mprice = item.price;
        if (this.changeselect == 45) {//中间
          this.SelectDesign.leftimg = item.leftimg;
          this.SelectDesign.rightimg = item.rightimg;
          this.SelectDesign.Mleftname = item.name;
          this.SelectDesign.Mrightname = item.name;
          this.SelectDesign.Mleftnameid = item.id;
          this.SelectDesign.Mrightnameid = item.id;
          this.SelectDesign.Cleftnameid = 0;
          this.SelectDesign.Crightnameid = 0;
        }
        if (this.changeselect == 90) {//单选右边
          this.SelectDesign.leftimg = item.leftimg;
          this.SelectDesign.Mrightname = item.name;
        //   this.SelectDesign.Cleftnameid = '';
        //   this.SelectDesign.Crightnameid = '';
          this.SelectDesign.Mrightnameid = item.id;
           this.SelectDesign.Crightnameid = 0;
        }
        if (this.changeselect == 1) {//滑块左边
          this.SelectDesign.rightimg = item.rightimg;
        //   this.SelectDesign.Cleftnameid = '';
        //   this.SelectDesign.Crightnameid = '';
          this.SelectDesign.Mleftname = item.name;
          this.SelectDesign.Mleftnameid = item.id;
           this.SelectDesign.Cleftnameid = 0;
        }
        // console.log(this.changeselect, this.SelectDesign)
      }
    },
    handleLeftimg2 (index, item) {
      this.PanelOtherColornumber = index;
      if (item.id) {
        this.PanelOtherid = item.id;
        // this.SelectDesign.Maddprice = item.price;

        if (this.changeselect == 45) {
          this.SelectDesign.addleftimg = item.leftimg;
          this.SelectDesign.addrightimg = item.rightimg;
          this.SelectDesign.Maddleftname = item.name;
          this.SelectDesign.Maddrightname = item.name;
          this.SelectDesign.Maddleftnameid = item.id;
          this.SelectDesign.Maddrightnameid = item.id;
           this.LPanelprice=item.price
         this.RPanelprice=item.price
        }
        if (this.changeselect == 1) {
          this.SelectDesign.addleftimg = item.leftimg;
          this.SelectDesign.Maddleftname = item.name;
          this.SelectDesign.Maddleftnameid = item.id;
           this.LPanelprice=item.price
        }
        if (this.changeselect == 90) {
          this.SelectDesign.addrightimg = item.rightimg;
          this.SelectDesign.Maddrightname = item.name;
          this.SelectDesign.Maddrightnameid = item.id;
            this.RPanelprice=item.price
        }
      this.SelectDesign.Maddprice=Math.max(this.RPanelprice,this.LPanelprice)
      }
    },
    //选择材质
    handleMLeftimg (index, item) {
    //   console.log('选择材质',this.changeselect)
      this.PanelMaterialnumber = item.id;
       
      if (item.id) {
        this.SelectDesign.addleftimg = "";
        this.SelectDesign.addrightimg = "";
        this.PanelColornumber = -1;
        this.PanelColornumber2 = -1;
        this.SelectDesign.Mprice = item.price;
        if (this.changeselect == 45) {
          this.SelectDesign.Mleftname = item.name;
          this.SelectDesign.Mrightname = item.name;
          this.SelectDesign.leftimg = item.leftimg;
          this.SelectDesign.rightimg = item.rightimg;
          this.SelectDesign.Cleftnameid = item.id;//材质赋值
          this.SelectDesign.Crightnameid = item.id;
           this.SelectDesign.Mleftnameid = 0;//颜色初始化
          this.SelectDesign.Mrightnameid = 0;
        
        }
        if (this.changeselect == 90) {
          this.SelectDesign.Mrightname = item.name;

          this.SelectDesign.leftimg = item.leftimg;
          this.SelectDesign.Crightname = item.name;
        //   this.SelectDesign.Mleftnameid = '';
        //   this.SelectDesign.Mrightnameid = '';

          this.SelectDesign.Crightnameid = item.id;
          this.SelectDesign.Mrightnameid = 0;

        }
        if (this.changeselect == 1) {
          this.SelectDesign.Mleftname = item.name;
          this.SelectDesign.Cleftnameid = item.id;
          this.SelectDesign.rightimg = item.rightimg;
          this.SelectDesign.Mleftnameid = 0;//颜色初始化
        //   this.SelectDesign.Mleftnameid = '';
        //   this.SelectDesign.Mrightnameid = '';

        }
      }
    },
    handleShellColor (index, id) {
      this.ShellColortype = index;
      this.ShellColorid = id;
    },
    //点击面板材质
    handlePanelMaterial (index, id) {
      this.PanelMaterialtype = index;
      this.PanelMaterialid = id;
    },
    //点击面板颜色
    handlePanelColor (index, id) {
      this.PanelColortype = index;
      this.PanelColorid = id;
    },

    //选择框出现
    selectChangeWires () {
      this.selectWiresVisable = !this.selectWiresVisable;
    },
    selectWires (index, item) {

      this.SelectDesign.Wid = item.pkid;
      this.SelectDesign.Wprice = item.price;
      this.SelectDesign.Wname = item.name;
      this.SelectDesign.Wleftimg = item.leftimg;
      this.SelectDesign.Wrightimg = item.rightimg;
      this.selectWiresVisable = !this.selectWiresVisable;

    },
    purchase () {
      this.$router.push("/WirelessHeadset");
    },
    changeselectleft () {
      this.changeselect = 1;

    },
    changeselectright () {
      this.changeselect = 90;

    },
    changeselectmiddle () {
      this.changeselect = 45;

    },
    back () {
      this.$router.push("/Design");
    },
    make (SelectDesign, SumPrice) {
  if(this.SelectDesign.Kaddrightname==''){
             this.SelectDesign.Kaddrightnameid =0
       }
       if(this.SelectDesign.Kaddleftname==''){
             this.SelectDesign.Kaddleftnameid =0
       }
 if(this.SelectDesign.Maddleftname==''){
             this.SelectDesign.Maddleftnameid =0
       }
       if(this.SelectDesign.Maddrightname==''){
             this.SelectDesign.Maddrightnameid =0
       }
       if(!(this.SelectDesign.Cleftnameid || this.SelectDesign.Mleftnameid)){
           this.$message({
            message: "请选择左耳面板颜色或者材质面板",
            type: 'error'
          });
          return;
      }
       if(!(this.SelectDesign.Crightnameid || this.SelectDesign.Mrightnameid)){
           this.$message({
            message: "请选择右耳面板颜色或者材质面板",
            type: 'error'
          });
          return;
      }
      //  if(!this.SelectDesign.Mrightnameid||!this.SelectDesign.Mleftnameid){
      //      this.$message({
      //       message: "请选择面板颜色或者材质面板",
      //       type: 'error'
      //     });
      //     return;
      // }
      //  if(!this.SelectDesign.Crightnameid||!this.SelectDesign.Cleftnameid){
      //      this.$message({
      //       message: "请选择面板颜色或者材质面板",
      //       type: 'error'
      //     });
      //     return;
      // }
      if (!this.SelectDesign.Krightnameid) {
        this.$message({
          message: "请选择左耳壳体颜色",
          type: 'error'
        });
        return;
      }
      if (!this.SelectDesign.Kleftnameid) {
        this.$message({
          message: "请选择右耳壳体颜色",
          type: 'error'
        });
        return;
      }
      //   if(!this.SelectDesign.Kleftnameid){
      //          this.$message({
      //           message: "请选择线材",
      //           type: 'error'
      //         });
      //         return;
      //     }


      this.$router.push({ path: "/DesignMake" });
      this.SelectDesign.SumPrice = this.SumPrice
      this.$store.dispatch("ChangeSelectDesign", SelectDesign);
    //   console.log('SelectDesign:' + JSON.stringify(SelectDesign))
      this.$store.dispatch("ChangeSumPrice", SumPrice);
    }
  }
};
</script>

<style scoped>
@import "../../static/global.css";
@import "../../static/newlayout.css";
</style>


// WEBPACK FOOTER //
// src/views/DesignColor.vue